import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"korean-rectangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4V20H2L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4V20L2 20L2 4L22 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 12V9H17.5294C17.6594 9 17.7647 9.09594 17.7647 9.21429V11.7857C17.7647 11.9041 17.6594 12 17.5294 12H14ZM14 12V15M18 15V14.4565C18 14.3935 17.9695 14.3337 17.9167 14.2929L15.5744 12.488L15.4792 12.4146M6 15V9M10 15V14.2531C10 14.1839 9.95544 14.119 9.88035 14.0788L6.5355 12.1531M10 9V9.74687C10 9.81607 9.95544 9.88102 9.88035 9.92124L6.5355 11.8469","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const KoreanRectangle = Vue.extend<IconProps>({
  name: 'KoreanRectangleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'korean-rectangle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default KoreanRectangle;
